/* global document */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import types from '../../common/model-api/types';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import LoggerView from '../loggers/LoggerView.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'logger.title', 'defaultMessage': 'Logger'},
});

interface FlowInvocationLoggerProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class FlowInvocationLogger extends React.Component<FlowInvocationLoggerProps> {

    typeName = 'flowInvocations';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    render() {
        let { user } = this.props;
        let { invocation: flowInvocation } = user.organisation.flow;

        let type = types[this.typeName];
        const apiHost = (document.getElementsByTagName('body').item(0).dataset.apihost) || '/api/v1';
        const flowInvocationId = flowInvocation.realId || flowInvocation.id;
        const downloadUrl = apiHost + '/flow-invocations/' + encodeURIComponent(flowInvocationId) + '/download-log';

        return (
            <AppPanel breadcrumbParams={[
                {type, data: flowInvocation},
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['flows'], data: this.props.user.organisation.flow}
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <LoggerView downloadUrl={downloadUrl} logger={flowInvocation.logger} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FlowInvocationLogger), (props) => {
    return props.user.organisation && props.user.organisation.flow && props.user.organisation.flow.invocation;
}), {
    initialVariables: {
        organisationId: '',
        flowId: '',
        flowInvocationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    flow(id: $flowId) {
                        id,
                        organisation_id,
                        name,
                        flowDef {
                            id,
                            name,
                        },
                        invocation(id: $flowInvocationId) {
                            id,
                            realId,
                            startType,
                            stats,
                            organisation_id,
                            flow_id,
                            finished,
                            debug,
                            finishedAt,
                            failed,
                            error,
                            nextRetry,
                            lastRun,
                            createdAt,
                            originalUrl,
                            originalRequest,
                            originalRequest2Preview,
                            originalHeaders,
                            resultStatusCode,
                            resultContentType,
                            resultResponse,
                            productVersion,
            				productStage,
                            priority,
                            logger(first: 300) {
                                ${LoggerView.getFragment('logger')}
                            }
                        }
                    }
                }
            }
        `,
    },
});
